import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from 'antd';
import { clsx } from 'clsx';
import { txt } from 'libs/i18n';
import MediaOriginsUpload from '../../MediaOriginsUpload';
import LinkUpload from '../../LinkUpload';
import styles from './style.module.less';
const MediaOrigin = ({ selectedSource, transcribeExistingProject }) => {
    const form = Form.useFormInstance();
    const originsList = Form.useWatch('originsList', form);
    return (_jsx(Form.Item, { name: "originsList", valuePropName: "mediaOriginsList", className: clsx(styles.originsList), rules: [
            {
                validator: (_, list) => {
                    return list.isEmpty()
                        ? Promise.reject(txt('insertMediaFile'))
                        : Promise.resolve();
                },
            },
        ], children: _jsxs(_Fragment, { children: [selectedSource === 'file' ? (_jsx(MediaOriginsUpload, { isSingleFileUpload: transcribeExistingProject, inputId: "input-media-files" })) : null, selectedSource === 'link' && (_jsx(LinkUpload, { mediaOriginsList: originsList, isSingleFileUpload: transcribeExistingProject }))] }) }));
};
export default MediaOrigin;
